import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Rating,
} from '@mui/material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const Storage = () => {
  const [facilities, setFacilities] = useState([]);
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    fetchFacilities();
    fetchBookings();
  }, []);

  const fetchFacilities = async () => {
    try {
      const response = await axios.get(`${API_URL}/storage/facilities`);
      setFacilities(response.data.facilities || []);
    } catch (error) {
      console.error('Error fetching facilities:', error);
    }
  };

  const fetchBookings = async () => {
    try {
      const response = await axios.get(`${API_URL}/storage/bookings`);
      setBookings(response.data.bookings || []);
    } catch (error) {
      console.error('Error fetching bookings:', error);
    }
  };

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Storage Solutions
      </Typography>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        Available Facilities
      </Typography>
      <Grid container spacing={3}>
        {facilities.map((facility) => (
          <Grid item xs={12} sm={6} md={4} key={facility.id}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {facility.name}
                </Typography>
                <Box display="flex" alignItems="center" mb={1}>
                  <Rating value={parseFloat(facility.avg_rating) || 0} readOnly size="small" />
                </Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {facility.address}
                </Typography>
                {facility.pricing_per_month && (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    ₹{facility.pricing_per_month}/month
                  </Typography>
                )}
              </CardContent>
              <CardActions>
                <Button size="small">View Details</Button>
                <Button size="small" variant="contained">
                  Book Storage
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>
        My Storage Bookings
      </Typography>
      {bookings.length === 0 ? (
        <Typography>No storage bookings yet</Typography>
      ) : (
        <Grid container spacing={3}>
          {bookings.map((booking) => (
            <Grid item xs={12} md={6} key={booking.id}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {booking.facility_name}
                  </Typography>
                  {booking.start_date && (
                    <Typography variant="body2" color="text.secondary">
                      Period: {new Date(booking.start_date).toLocaleDateString()} -{' '}
                      {booking.end_date
                        ? new Date(booking.end_date).toLocaleDateString()
                        : 'Ongoing'}
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default Storage;

